if (!window.__lazyVideoInit) {
  window.__lazyVideoInit = true;

  function hydrateVideo(video) {
    if (video.dataset.hydrated === 'true') return;
    video.dataset.hydrated = 'true';
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].dataset.src;
    }
    video.load();
    var playAttempt = video.play();
    if (playAttempt && playAttempt.catch) { playAttempt.catch(function () {}); }
  }

  function observeLazyVideos() {
    var videos = document.querySelectorAll('video[data-lazy-video]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < videos.length; i++) { hydrateVideo(videos[i]); }
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          hydrateVideo(video);
          if (video.paused) { var p = video.play(); if (p && p.catch) { p.catch(function () {}); } }
        } else if (video.dataset.hydrated === 'true' && !video.paused) {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.1 });

    for (var j = 0; j < videos.length; j++) { observer.observe(videos[j]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeLazyVideos);
  } else {
    observeLazyVideos();
  }

  document.addEventListener('shopify:section:load', observeLazyVideos);
}
